// extracted by css-extract-rspack-plugin
export default {"box":"Spinner-module__box___wMbsi","ring":"Spinner-module__ring___FpqNR","spin":"Spinner-module__spin___nfxeD"};